import Modal, { ModalProps } from "components/Modal"

export const ViewPost = (props: ModalProps) => {
  return (
    <Modal {...props}>
      <div>Foo</div>
    </Modal>
  )
}
